/*=============================================== DatepickerPage ===============================================*/

import { useState } from "react"
import { Datepicker } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import {
    commonProps,
    inputVariants,
    inputBackgroundColor,
    listDirection,
    inputLabel,
    validationObject,
    iconBoxicon,
} from "data"

const DatepickerPage = () => {
    const [selectedDate, setSelectedDate] = useState<Date>(new Date())

    const items: ItemType[] = [
        {
            content: (
                <Datepicker
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    minDate={new Date()}
                    maxDate={new Date("2024-04-12")}
                    label="Calendar"
                />
            ),
            code: 'const [selectedDate, setSelectedDate] = useState(new Date())\n\n<Datepicker\n    selectedDate={selectedDate}\n    setSelectedDate={setSelectedDate}\n    minDate={new Date()}\n    maxDate={new Date("2024-04-12")}\n    label="Calendar"\n/>',
            codeTs: 'const [selectedDate, setSelectedDate] = useState<Date>(new Date())\n\n<Datepicker\n    selectedDate={selectedDate}\n    setSelectedDate={setSelectedDate}\n    minDate={new Date()}\n    maxDate={new Date("2024-04-12")}\n    label="Calendar"\n/>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "selectedDate",
            type: "Date",
            required: true,
        },
        {
            subtitle: "setSelectedDate",
            type: "function",
            required: true,
        },
        {
            subtitle: "minDate",
            type: "Date",
        },
        {
            subtitle: "maxDate",
            type: "Date",
        },
        inputVariants("inputVariant"),
        inputBackgroundColor(),
        listDirection("calendarDirection"),
        "separator",
        {
            subtitle: "iconSize",
            intro: (
                <>
                    For the <code>icons.icon</code>.
                </>
            ),
            type: "number",
            default: 24,
        },
        {
            subtitle: "icons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>icons</code> object
                </>
            ),
            subtitle: "icon",
            intro: commonProps.addIconCapital,
            type: "string",
        },
        {
            subtitle: "prev",
            type: "string",
            default: iconBoxicon("chevron-left"),
        },
        {
            subtitle: "next",
            type: "string",
            default: iconBoxicon("chevron-right"),
        },
        {
            subtitle: "calendar",
            type: "string",
            default: iconBoxicon("calendar"),
        },
        ...inputLabel(),
        ...validationObject(),
        "separator",
        {
            subtitle: "texts",
            type: "object",
        },
        {
            title: (
                <>
                    <code>texts</code> object
                </>
            ),
            subtitle: "weekDays",
            intro: "In case you want to change the names of the weekdays (for example in another language).",
            type: "object",
            default:
                '{ mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday", fri: "Friday", sat: "Saturday", sun: "Sunday" }',
            required: true,
        },
        {
            subtitle: "months",
            intro: "In case you want to change the names of the months (for example in another language).",
            type: "object",
            default:
                '{ jan: "January", feb: "February", mar: "March", apr: "April", may: "May", jun: "June", jul: "July", aug: "August", sep: "September", oct: "October", nov: "November", dec: "December" }',
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default DatepickerPage
